export default __webpack_public_path__ + "static/media/marker.cd713242.png";